export const roleLabels = { owner: 'Владелец', marketer: 'Маркетолог', operator: 'Оператор', viewer: 'Просмотр', member: 'Просмотр', familiarization: 'Ознакомление' };
export const roleDescriptions = {
  familiarization: 'Обзор всех разделов на 48 часов: обезличенные сводки и структура цепочек. Без контактов, секретов, изменений, отправок и выгрузок.',
  owner: 'Полный доступ: настройки, команда, выгрузки, бонусы и журнал действий.',
  marketer: 'Просмотр рабочих разделов, сегменты, шаблоны и запуск рассылок. Без настроек, импорта, выгрузок и изменения бонусов.',
  operator: 'Просмотр рабочих разделов, создание и изменение клиентов, создание, подтверждение и отмена заказов. Заказ может начислить или вернуть бонусы по правилам программы.',
  viewer: 'Просмотр рабочих разделов без изменений и выгрузок.',
};
const ownerPages = ['/mobile-apps','/wallet','/referrals','/gift-cards','/reports','/integrations','/crm','/bots','/entry-points','/max','/web-pixel','/team','/billing','/audit'];
export function canOpen(role, path) {
  if (!roleLabels[role]) return false;
  if (role === 'familiarization') return !path.startsWith('/platform');
  return role === 'owner' || !ownerPages.some(p => path === p || path.startsWith(p + '/'));
}
